import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./routes/Home";
import PortfolioPage from "./routes/PortfolioPage";
import ServicesPage from "./routes/Services";
import AboutPage from "./routes/AboutMePage";
import PricingPage from "./routes/Pricing";
import ContactSection from "./components/homeComponents/Contact";
import ContactPage from "./routes/ContactPage";
import AboutSection from "./components/homeComponents/AboutMe";
import LegalPage from "./routes/LegalPage";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about-me" element={<AboutSection />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms-and-conditions" element={<LegalPage />} />
      </Routes>
      <ContactSection />
    </div>
  );
}

export default App;
